import { formatPhone } from "shared/utils/format-phone";
import { formatToCurrency } from "shared/utils/currency";

export const formatPhoneDisplay = (phone: string | null | undefined) => {
  if (!phone) return "—";
  return formatPhone(phone);
};

// BE returns price in major units (e.g. "3.50"), `formatToCurrency` expects
// cents — convert before passing through. Falls back to "—" if price is not
// a finite number.
const formatMonthlyPrice = (
  price: string | null | undefined,
  unit: string | null | undefined
) => {
  if (!price) return "—";
  const value = Number(price);
  if (!Number.isFinite(value)) return "—";
  return formatToCurrency({
    cents: Math.round(value * 100),
    currency: (unit ?? "USD").toUpperCase()
  });
};

export const formatMonthlyFee = (
  price: string | null | undefined,
  unit: string | null | undefined,
  isFree: boolean
) => {
  if (isFree) return "Free";
  return formatMonthlyPrice(price, unit);
};

const COUNTRY_FLAG: Record<string, string> = {
  US: "🇺🇸",
  CA: "🇨🇦",
  GB: "🇬🇧",
  AU: "🇦🇺"
};

export const countryFlag = (country?: string | null) =>
  country ? (COUNTRY_FLAG[country.toUpperCase()] ?? "") : "";
